import styled, { css } from 'styled-components';

import { BlockSize } from 'libs/rendering/gltf/config';

const legendRowHeight = 23;
const legendTitleHeight = 23;

export const LegendWrapper = styled.nav`
  height: ${props =>
    (props.steps + 1) * legendRowHeight +
    legendTitleHeight -
    0.5 * legendRowHeight +
    5}px;
  bottom: ${1.25 * legendRowHeight}px;
  right: ${props => props.right}px;
  margin: ${props => props.theme.spacing.small};
  padding: ${props => props.theme.spacing.default};
  position: absolute;
  background: ${props => props.isDark && props.theme.color.wfBlack};
  border-radius: 5px;
  color: ${props =>
    props.isDark ? props.theme.color.wfWhite : props.theme.color.wfBlack};
  font-size: 0.8rem;
  display: ${props => (props.visible ? 'block' : 'none')};
`;

export const UnitsWrapper = styled.nav`
  height: ${legendTitleHeight}px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 0.85rem;
  text-align: center;
`;

export const GradientWrapper = styled.nav`
  top: ${legendTitleHeight}px;
  width: ${BlockSize.circle};
  height: ${props => props.steps * legendRowHeight + 1}px;
  right: ${props => props.theme.spacing.small};
  border: 1px solid
    ${props =>
      props.isDark ? props.theme.color.wfWhite : props.theme.color.wfBlack};
  position: absolute;
`;

export const Gradient = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  ${props =>
    props.continuous &&
    css`
      background: linear-gradient(
        to bottom,
        #ff0000 ${props.cutOffPerc}%,
        #ffff00 ${(3.0 * props.cutOffPerc + 100.0) / 4.0}%,
        #00ff00 ${(props.cutOffPerc + 100.0) / 2.0}%,
        #00ffff ${(props.cutOffPerc + 300.0) / 4.0}%,
        #0000ff
      );
    `}
`;

export const CutOffLevel = styled.div`
  position: absolute;
  display: ${props =>
    props.cutOffPerc >= 0 && props.cutOffPerc <= 100 ? 'block' : 'none'};
  width: calc(100% + 6px);
  left: -3px;
  height: 0px;
  top: calc(${props => props.cutOffPerc}%);
  border: 1px solid ${props => props.theme.color.wfPurple};
`;

export const GradientLabels = styled.div`
  display: flex;
  flex-direction: column;
  position: aboslute;
  right: ${BlockSize.circle};
  margin-top: ${legendTitleHeight - 0.5 * legendRowHeight - 1}px;
`;

export const GradientBox = styled.div`
  display: flex;
  flex-direction: column;
  height: ${props => legendRowHeight / props.grain}px;
  position: aboslute;
  right: ${BlockSize.circle};
  background: ${props => props.color && props.color};
  border-bottom: 1px solid ${props => props.theme.color.wfWhite}40;

  ${props =>
    props.colorNext &&
    css`
      background: linear-gradient(
        to bottom,
        ${props.color} ${props.perc}%,
        ${props.colorNext}
      );
    `}
`;

export const GradientLabel = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: ${legendRowHeight - 0.1}px;
  bottom: ${0.5 * legendRowHeight}px;
  padding-right: 6px;
  right: ${0.5 * legendRowHeight - 2}px;

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
    border-right: 4px solid
      ${props =>
        props.isDark ? props.theme.color.wfWhite : props.theme.color.wfBlack};
    right: 2px;
    top: ${0.5 * legendRowHeight - 3}px;
  }
`;
